import { api } from "./api";
import type { AuthUser } from "@/contexts/AuthContext";

// Self-service account updates. Both return the refreshed user (UserDto shape).
export function updateProfile(input: { fullName: string; phone?: string; preferredLanguage?: string }): Promise<AuthUser> {
  return api<AuthUser>("/account/profile", { method: "PUT", body: input });
}

export function updateNotificationPrefs(notifyByEmail: boolean, notifyByWhatsApp: boolean): Promise<AuthUser> {
  return api<AuthUser>("/account/notifications", { method: "PUT", body: { notifyByEmail, notifyByWhatsApp } });
}
